// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-header-secondary-nav-toggle{display:none}@media(min-width:992px){.site-header-secondary-nav-toggle{display:inline-flex}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
